module.exports = __webpack_public_path__ + "img/payment-systems.bbe3666a.svg";